<div class="wrapper limit-width-on-desktop">
  <div class="head-section">
    <div class="img-div">
      <img src="assets/logos/primary.svg" alt="" />
    </div>
    <div class="top-text">
      <h2 class="h2-medium">Welcome</h2>
    </div>
  </div>
  <div class="login-form">
    <ion-item mode="ios" [class.error-input]="emailError">
      <ion-input labelPlacement="floating" #emailField [(ngModel)]="userEmail" (keydown)="onEnterEmailField($event)" (input)="setEmail($event)" type="email">
        <div slot="label">
          <ion-text class="standard-input-label">Email</ion-text>
        </div>
      </ion-input>
    </ion-item>
    <div *ngIf="emailError">
      <p class="error-message">This field is required</p>
    </div>
    <ion-item mode="ios" class="password-item" native>
      <ion-input
        label="Password"
        labelPlacement="floating"
        #passwordField
        [(ngModel)]="password"
        (keydown)="onEnterPasswordField($event)"
        (input)="validatePassword($event)"
        type="{{ passwordType }}"
        class="ion-align-self-center"
      ></ion-input>
      <ion-icon slot="end" src="assets/icon/input-icons/{{ passwordIcon }}.svg" class="password-icon" (click)="showPassword()">
      </ion-icon>
    </ion-item>
    <div *ngIf="passwordError">
      <p class="error-message">Password field cannot be left blank</p>
    </div>

    <a class="forgot" appEventTracking eventType="button" (click)="forgotPassword()">Forgot password</a>
    <br />
    <div class="button-row">
      <ion-button mode="ios" class="primary-button" (click)="loginWithEmailAndPassword()" [disabled]="disableButtonEmail || disableButtonPassword">
        Log in
      </ion-button>
    </div>
    <div class="button-row" *ngIf="!sharedConfig.routeParamUserMsisdn && sharedConfig.routeParamLogInWithOTP && !showOTPScreen">
      <ion-button mode="ios" class="primary-button" (click)="requestOTPValidateIfUserExistInDB()" [disabled]="disableButtonCell">
        Request OTP
      </ion-button>
    </div>
    <div
      class="pb-230"
      *ngIf="!sharedConfig.routeParamUserMsisdn && sharedConfig.showSetNewPasswordButtonOnLogin && !sharedConfig.routeParamLogInWithOTP"
    >
      <ion-button mode="ios" class="secondary-button" (click)="forgotPassword()"> Set a new password </ion-button>
    </div>
  </div>
  <div class="mini-version">
    <p>{{sharedConfig.appVersion}}</p>
  </div>
</div>

<popup-dialog id="loginWithEmailAndPassword.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>

<custom-popup *ngIf="showMinReqPasswordPopup">
  <div class="text-center">
    <h2 class="h2-bold">Set a new password</h2>
  </div>
  <div class="sub-header">
    <p>Our password policy has been updated. Your current password does not meet our minimum requirements.
    Your new password must contain:</p>
  </div>
  <div>
    <ul style="margin: auto; width: 250px;">
      <li>at least 8 characters</li>
      <li>a lower case character</li>
      <li>an upper case character</li>
      <li>a special character</li>
      <li>a numeric character</li>
    </ul>
    <p class="text-center">
      We have sent you an email with instructions to reset your password.
    </p>
  </div>
  <div class="buttons-wrapper">
    <ion-button mode="ios" class="primary-button" (click)="closeMinReqPasswordPopup()"> OK </ion-button>
  </div>
</custom-popup>

@if (showUpdateScreen) {
<div class="update-page">
  <div class="lottie-frame">
    <lottie-player autoplay loop mode="normal" src="assets/lottie-animations/update.json"> </lottie-player>
  </div>
  <div class="body">
    <h1>Update required</h1>
    <p>You are a version behind please update to latest version.</p>
    <div class="buttons">
      <ion-button mode="ios" color="blue" class="primary-button" (click)="updateNow()"> Update now </ion-button>
    </div>
  </div>
</div>
}
<!-- todo: Josh, this popup is completely DARK/Blank whne opening up - Only on staging (using hosted endtpoin). locally it works fine -->
<!-- <small-popup *ngIf="sharedConfig.showPopupWithDismissButton_updateApp" [header]="'New version available'" [message]="'Updating to latest version...'">
  <ion-button mode="ios" class="primary-button" (click)="closeUpdateAppPage()"> Ok </ion-button>
</small-popup> -->
